'use strict'
import angular from 'angular';

angular.module('tasksFilter').factory('TasksFilterOptionsProviderFactory', [
    'TasksFilterTestOptionsProvider',
    'TasksFilterDefaultOptionsProvider',
    'TasksFilterDetailedOrdersOptionsProvider',
    function (TasksFilterTestOptionsProvider, TasksFilterDefaultOptionsProvider, TasksFilterDetailedOrdersOptionsProvider) {
        return {
            makeOptionsProviderFor(name) {
                switch (name) {
                    case 'default':
                        return TasksFilterDefaultOptionsProvider
                    case 'test':
                        return TasksFilterTestOptionsProvider
                    case 'detailedOrders':
                        return TasksFilterDetailedOrdersOptionsProvider
                    default:
                        throw 'Unknown options provider: ' + name
                }
            }
        }
    }])